// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__MD3W4","image":"Header_image__2Axio","name":"Header_name__3HlbS","info":"Header_info__3lOA7","infoRow":"Header_infoRow__2kNov"};